<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">
                The total offer prices for all line items <strong>({{buyerThresholdCheck.currency}} {{buyerThresholdCheck.totalFinalPrice}}) </strong>
                under PR# {{buyerThresholdCheck.prNumber}} and the threshold value is
                <strong>{{buyerThresholdCheck.currency}} {{buyerThresholdCheck.thresholdAmount}}</strong>.
            </div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card-body p-2">
                <div class="d-flex justify-content-between mt-2 mb-4">
                    <p class="mb-0">
                        <span class="fa fa-check-circle me-2 text-success"></span>
                        You can go ahead with acceptance of counter offer.
                    </p>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead class="table-active">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Line Item#</th>
                                <th scope="col">Supplier Name</th>
                                <th scope="col">Final Offer</th>
                                <th scope="col">Tax</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Total Price (Including Tax)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let lineItemMap of lineNumberQuotationMap; let i = index">
                                <th scope="row">{{i+1}}.</th>
                                <td>{{lineItemMap?.line_item_number}}</td>
                                <td>
                                    {{lineItemMap?.vendorName}}
                                </td>
                                <td>
                                    <ng-container>
                                        {{ lineItemMap?.currency }}
                                        {{ lineItemMap?.finalOffer | number:'1.1-3'}}
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container>
                                        {{ lineItemMap?.tax}}%
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container>
                                        {{ lineItemMap?.quantity}}
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container>
                                        {{ lineItemMap?.currency }}
                                        {{ lineItemMap?.total_price | number:'1.1-3'}}
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <!-- <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button> -->
            <button class="btn btn-primary mx-2 text-white" (click)="closeModal()">Ok</button>
        </div>
    </div>
</section>